import { render, staticRenderFns } from "./SpecialSaving.vue?vue&type=template&id=43e1b4dc"
import script from "./SpecialSaving.vue?vue&type=script&lang=js"
export * from "./SpecialSaving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports